import { useEffect, useState } from "react";
import { classNames } from "../../shared/utility";
import ImportMediaDropzone from "./ImportMediaDropzone";
import { DocumentIcon } from "@heroicons/react/24/outline";

export default function MediaUi(props) {
  const {
    title,
    uploadedImage,
    isEdit,
    imageUrl,
    imageName,
    handleInputChange,
    onDelete,
    setUploadedImage,
  } = props;

  const [isPdf, setIsPdf] = useState(false);

  useEffect(() => {
    if (imageUrl) {
      const path = imageUrl.split("?")[0];
      const extension = path.split(".").pop()?.toLowerCase();
      setIsPdf(extension === "pdf");
    } else {
      setIsPdf(false);
    }
  }, [imageUrl]);

  const uploadedPreviewUrl = uploadedImage?.url;
  const uploadedIsPdf = Boolean(uploadedImage?.isPdf);
  // Pending upload: icon only. After save (URL set, preview cleared): Upload / View / Delete.
  const showActions = Boolean(imageUrl) && !uploadedImage;
  const showUpload = !uploadedImage;

  return (
    <div>
      <div className="flex space-x-2">
        <label
          htmlFor="imageName"
          className="block text-sm font-medium text-gray-900"
        >
          {title}
        </label>
      </div>
      {uploadedImage ? (
        uploadedIsPdf ? (
          <DocumentIcon
            className="h-32 w-32 text-gray-400"
            aria-hidden="true"
          />
        ) : (
          <div>
            <img
              src={uploadedPreviewUrl}
              height="200"
              width="200"
              alt="Uploaded document"
            />
          </div>
        )
      ) : isEdit ? (
        imageUrl ? (
          isPdf ? (
            <DocumentIcon
              className="h-32 w-32 text-gray-400"
              aria-hidden="true"
            />
          ) : (
            <img
              src={imageUrl}
              alt={imageName}
              title={imageName}
              className="media-image rounded-md"
              height="200"
              width="200"
            />
          )
        ) : null
      ) : null}
      <div className="flex mt-2 gap-2">
        <div className={classNames(showUpload ? "" : "hidden")}>
          <ImportMediaDropzone
            fileName={imageName}
            handleInputChange={handleInputChange}
            setUploadedImage={setUploadedImage}
          />
        </div>
        <a
          type="button"
          className={classNames(
            showActions
              ? "rounded-md bg-yellow-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-700"
              : "hidden"
          )}
          href={imageUrl}
          target="_blank"
          rel="noreferrer"
        >
          View
        </a>
        <button
          type="button"
          className={classNames(
            showActions
              ? "rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-700"
              : "hidden"
          )}
          onClick={onDelete}
        >
          Delete
        </button>
      </div>
    </div>
  );
}
